<template>
    <div>
        <app-sub-title text="Filtros" />
        <b-card>
            <div class="card-text">
                <b-row>
                    <b-col align-h="center" cols="12" md="4" lg="4" v-if="canSelectClient">
                        <app-autocomplete
                            placeholder="Cliente"
                            :items="clients"
                            v-model="selectClient"
                        />
                    </b-col>
                    <b-col cols="12" md="2" lg="1" offset-lg="10">
                        <b-button variant="primary" class="btn-block" @click="$emit('filter', filters)"><i class="fa fa-filter"></i></b-button>
                    </b-col>
                    <b-col cols="12" md="2" lg="1">
                        <b-button variant="secondary" class="btn-block" @click="clearFilters"><i class="fa fa-times-circle"></i></b-button>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>
<script>
import Autocomplete from '../../../UI/Controls/AutocompleteV2/Autocomplete.vue';
import { mapGetters } from 'vuex';
export default {
    components: {
        appAutocomplete: Autocomplete
    },
    data(){
        return {
            filters: {
                client: ''
            },
            selectClient: '',
        }
    },
    watch:{
        selectClient(val){
            if(!val){
                this.filters.client= '';
                this.selectClient = '';
            }else{
                this.filters.client = val.id;
            }
        }
    },
    computed: {
        ...mapGetters(['clients']),
        canSelectClient() {
            return !this.user.profile.client_side;
        }
    },
    methods: {
        clearFilters(){
            this.selectClient= '';
            Object.keys(this.filters).map(key => this.filters[key] = '');
            this.$emit('filter', null);
        }
    }
}
</script>

